import { Button } from "@heroui/button";
import { Link as PropLink } from "@heroui/link";
import { Navbar, NavbarBrand, NavbarContent } from "@heroui/navbar";
import {
  Avatar,
  Divider,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "sonner";

import { ThemeSwitch } from "../components/theme-switch";
import { useLogout } from "../features/Auth/AuthApi";
import { AuthStore } from "../store/useAuthStore";

import Header from "@/features/ui/Header.tsx";

const NavbarTop = () => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const location = useLocation();

  const { userInfo } = AuthStore();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  let content;
  let publicContent;

  const { mutateAsync, isSuccess, reset } = useLogout();

  const handleLogout = () => {
    toast.promise(mutateAsync(), {
      loading: "Logging out...",
      success: "Successfully logged out",
      error: "Error logging out",
      position: "top-right",
      duration: 1000,
    });
    if (isSuccess) {
      reset();
    }
  };

  if (
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/reset" ||
    location.pathname === "/demo" ||
    location.pathname === "/about" ||
    location.pathname === "/contact-us" ||
    location.pathname === "/look-up" ||
    location.pathname === "/forgotPassword" ||
    location.pathname.startsWith("/resetPassword/") ||
    location.pathname === "/"
  ) {
    publicContent = (
      <>
        <Header />
      </>
    );
  } else {
    publicContent = (
      <>
        <Navbar
          isBlurred
          isBordered
          height={"50px"}
          maxWidth="xl"
          position="sticky"
        >
          <NavbarBrand>
            <Link
              className="font-nomal text-inherit select-none text-gray-400"
              to="/home"
            >
              <h3 className={"font-semibold"}>Silagreen Genetics</h3>
            </Link>
          </NavbarBrand>

          <NavbarContent as="div" justify="end">
            <Dropdown placement="bottom-end">
              <div className="flex flex-row gap-4 items-center">
                <DropdownTrigger>
                  <Avatar
                    isBordered
                    as="button"
                    className="transition-transfor select-none"
                    classNames={{
                      base: "h-4 w-4",
                      img: "h-4 w-4",
                    }}
                    name="Jason Hughes"
                    size="sm"
                    src="https://i.pravatar.cc/150?u=a042581f4e29026704d"
                  />
                </DropdownTrigger>
                <ThemeSwitch />
              </div>
              <DropdownMenu aria-label="Profile Actions" variant="flat">
                <DropdownItem key="profile" className="h-14 gap-2">
                  <p className="font-semibold">{userInfo.firstname}</p>
                  <p className="font-semibold">{userInfo.email}</p>
                  <p className="font-mono text-gray-400">{userInfo.id}</p>
                  <Divider />
                </DropdownItem>
                <DropdownItem key="settings">Settings</DropdownItem>
                <DropdownItem key="logout" color="danger">
                  <Button
                    fullWidth
                    color="default"
                    variant="flat"
                    onClick={onOpen}
                  >
                    Log Out
                  </Button>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </NavbarContent>
        </Navbar>
        <Modal
          isDismissable={false}
          isKeyboardDismissDisabled={true}
          isOpen={isOpen}
          placement="center"
          onOpenChange={onOpenChange}
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalBody>
                  <ModalHeader className="flex justify-center">
                    <h2>Are You Sure You Want To Log Out</h2>
                  </ModalHeader>
                  <ModalBody>
                    <Button
                      className={"text-gray-950 dark:gray-300"}
                      color="danger"
                      variant="ghost"
                      onClick={handleLogout}
                      onPress={onClose}
                    >
                      Yes Log Out
                    </Button>
                    <Button color="primary" variant="solid" onPress={onClose}>
                      No Please Return
                    </Button>
                  </ModalBody>
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </>
    );
  }

  if (location.pathname === "/login") {
    content = (
      <Button as={PropLink} href="/register" variant="flat">
        Sign Up
      </Button>
    );
  } else if (location.pathname === "/register") {
    content = (
      <Button as={PropLink} color="default" href="/login">
        Sign In
      </Button>
    );
  }

  return <>{publicContent}</>;
};

export default NavbarTop;
